import { render, staticRenderFns } from "./SSHeader.vue?vue&type=template&id=13e6a489&scoped=true&"
import script from "./SSHeader.vue?vue&type=script&lang=js&"
export * from "./SSHeader.vue?vue&type=script&lang=js&"
import style0 from "./SSHeader.vue?vue&type=style&index=0&id=13e6a489&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13e6a489",
  null
  
)

export default component.exports